import styled from '@emotion/styled';

export const PresentersContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    padding-top: 8px;
`;
